import client from '@/api/client.js';
import store from "@/store";
//import i18n from '@/plugins/i18n.js'
export default {
    methods: {
        async getContractTypeMap() {
            var meta = { clientApiMethod: 'getContractTypeMap', input: {} }
            var response = await client().get(store.state.apiRouteRoot + "ContractType/Map", { meta: meta })
            return response?.data;
        },

        async getContractTypeListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getContractTypeListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "ContractType/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },

        async getContractType(contractTypeId) {
            var meta = { clientApiMethod: 'getContractType', input: { contractTypeId: contractTypeId } }
            var response = await client().get(store.state.apiRouteRoot + "ContractType/" + contractTypeId, { meta: meta })
            return response?.data;
        },

        async createContractType(newContractType) {
            var meta = {
                clientApiMethod: 'createContractType',
                input: { newContractType },
                //successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.lead.lead_type") })
            }
            var response = await client().put(store.state.apiRouteRoot + 'ContractType', newContractType, { meta: meta })
            return response?.data;
        },

        async changeContractType(updatedContractType) {
            var meta = {
                clientApiMethod: 'changeContractType',
                input: { updatedContractType },
                //successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.lead.lead_type") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'ContractType', updatedContractType, { meta: meta })
            return response?.data;
        },

        async deleteContractType(contractTypeId) {
            var meta = {
                clientApiMethod: 'deleteContractType',
                input: { contractTypeId: contractTypeId },
                //successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.lead.lead_type") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "ContractType/" + contractTypeId, { meta: meta })
            return response?.data;
        },
    }
}